import { Component, Input } from '@angular/core';
import { OfferTypeCodeEnum } from '../../../../features/offers/models/enums/OfferTypeCodeEnum';

@Component({
  selector: 'app-offer-type',
  standalone: false,
  templateUrl: './offer-type.component.html'
})
export class OfferTypeComponent {
  @Input() offerTypeCode: OfferTypeCodeEnum
  offerTypeCodeEnum = OfferTypeCodeEnum
}
